import Container from '@/components/Container';
import {
  BookmarkPage,
  BookmarkPageQuery,
  BookmarkPageQueryVariables,
  Enum_Bookmark_Category,
  FetchResourceTypesQuery,
  FetchResourceTypesQueryVariables,
  QUERY_BOOKMARK_PAGE,
  QUERY_RESOURCE_TYPES,
} from '@edwin-group/cj-graphql';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { useSuspenseQuery } from '@apollo/client';
import ResourcesListCard from './components/resources';
import CourseBookmarkListCard from './components/course';
import ChapterBookmarkListCard from './components/chapter';
import { Suspense } from 'react';
import { LoadingContainer } from '../reporting-tools/components/loading-container';

function BookmarkPageComponent() {
  const { data } = useSuspenseQuery<BookmarkPageQuery, BookmarkPageQueryVariables>(QUERY_BOOKMARK_PAGE, {
    fetchPolicy: 'cache-first',
  });
  const bookmarkPage = data?.bookmarkPage as BookmarkPage;

  const { data: resourceTypeResult } = useSuspenseQuery<FetchResourceTypesQuery, FetchResourceTypesQueryVariables>(
    QUERY_RESOURCE_TYPES,
    {
      fetchPolicy: 'cache-first',
    },
  );

  return (
    <Container className="pb-sh-60" addMargin>
      <div className="col-span-12 min-h-[30rem] md:col-start-3 md:col-end-11">
        <section className="mb-sh-30">
          <AnimatedFadeInComponent>
            <h1 className="font-cadiz text-sh-lg">{bookmarkPage?.yourBookmarkTitle}</h1>
          </AnimatedFadeInComponent>
        </section>

        <section>
          <CourseBookmarkListCard category={Enum_Bookmark_Category.Cpd} page={bookmarkPage} />
        </section>

        <section>
          <CourseBookmarkListCard category={Enum_Bookmark_Category.Training} page={bookmarkPage} />
        </section>

        <section>
          <ChapterBookmarkListCard category={Enum_Bookmark_Category.Chapter} page={bookmarkPage} />
        </section>

        <section>
          {resourceTypeResult?.resourceTypes?.map((resourceType) => (
            <>
              <ResourcesListCard
                type={resourceType!.type}
                category={Enum_Bookmark_Category.Resource}
                page={bookmarkPage}
              />
            </>
          ))}
        </section>
      </div>
    </Container>
  );
}

export function BookmarkPageScreen() {
  return (
    <Suspense fallback={<LoadingContainer title="Loading bookmarks..." />}>
      <BookmarkPageComponent />
    </Suspense>
  );
}
